module.exports = __webpack_public_path__ + "static/media/arrow-right.39b30ed5.svg";